<template>
  <div class="main-page">
    <template v-if="showHeader">
      <section class="page-section">
        <div class="container">
          <div class="grid justify-content-between">
            <div class="col">
              <div class="">
                <div class="text-3xl font-bold">Edit User Account</div>
              </div>
            </div>
          </div>
        </div>
      </section>
      <hr />
    </template>
    <section class="page-section pt-2">
      <div class="container">
        <div class="grid">
          <div class="md:col-9 sm:col-12 comp-grid">
            <div class="">
              <div class="">
                <div>
                  <template v-if="pageReady">
                    <div class="grid">
                      <div class="col-12">
                        <form
                          ref="observer"
                          tag="form"
                          @submit.prevent="submitForm()"
                          class=""
                          :class="{ card: !isSubPage }"
                        >
                          <!--[form-content-start]-->
                          <div class="grid">
                            <div class="col-12 md:col-6">
                              <div class="mb-2 font-bold text-sm">
                                First Name *
                              </div>
                              <div id="ctrl-first_name-holder">
                                <InputText
                                  ref="ctrlfirst_name"
                                  v-model.trim="formData.first_name"
                                  label="First Name"
                                  type="text"
                                  placeholder="Enter First Name"
                                  class="w-full"
                                  :class="getErrorClass('first_name')"
                                >
                                </InputText>
                                <small
                                  v-if="isFieldValid('first_name')"
                                  class="p-error"
                                  >{{ getFieldError("first_name") }}</small
                                >
                              </div>
                            </div>
                            <div class="col-12 md:col-6">
                              <div class="mb-2 font-bold text-sm">
                                Last Name *
                              </div>
                              <div id="ctrl-last_name-holder">
                                <InputText
                                  ref="ctrllast_name"
                                  v-model.trim="formData.last_name"
                                  label="Last Name"
                                  type="text"
                                  placeholder="Enter Last Name"
                                  class="w-full"
                                  :class="getErrorClass('last_name')"
                                >
                                </InputText>
                                <small
                                  v-if="isFieldValid('last_name')"
                                  class="p-error"
                                  >{{ getFieldError("last_name") }}</small
                                >
                              </div>
                            </div>
                            <div class="col-12 md:col-6">
                              <div class="mb-2 font-bold text-sm">
                                Telephone Ext. *
                              </div>
                              <div id="ctrl-telephone-holder">
                                <InputText
                                  ref="ctrltelephone"
                                  v-model.trim="formData.telephone"
                                  maxlength="12"
                                  minlength="3"
                                  pattern="^[0-9]+$"
                                  label="Telephone"
                                  type="text"
                                  :disabled="true"
                                  placeholder="Enter Telephone Ext."
                                  class="w-full"
                                  :class="getErrorClass('telephone')"
                                >
                                </InputText>
                                <small
                                  v-if="isFieldValid('telephone')"
                                  class="p-error"
                                  >{{ getFieldError("telephone") }}</small
                                >
                              </div>
                            </div>
                            <div class="col-12 md:col-6">
                              <div class="mb-2 font-bold text-sm">Region *</div>
                              <div id="ctrl-region-holder">
                                <api-data-source
                                  api-path="components_data/region_option_list"
                                >
                                  <template v-slot="req">
                                    <Dropdown
                                      class="w-full"
                                      :class="getErrorClass('region')"
                                      :loading="req.loading"
                                      optionLabel="label"
                                      optionValue="value"
                                      ref="ctrlregion"
                                      v-model="formData.region"
                                      :options="req.response"
                                      label="Region"
                                      placeholder="Select ..."
                                    >
                                    </Dropdown>
                                    <small
                                      v-if="isFieldValid('region')"
                                      class="p-error"
                                      >{{ getFieldError("region") }}</small
                                    >
                                  </template>
                                </api-data-source>
                              </div>
                            </div>
                            <div class="col-12 md:col-6">
                              <div class="mb-2 font-bold text-sm">
                                District *
                              </div>
                              <div id="ctrl-district-holder">
                                <api-data-source
                                  @loaded="formData.district = ''"
                                  :load-on-mount="false"
                                  :api-path="`components_data/district_option_list?lookup_region=${formData.region}`"
                                >
                                  <template v-slot="req">
                                    <Dropdown
                                      class="w-full"
                                      :class="getErrorClass('district')"
                                      :loading="req.loading"
                                      optionLabel="label"
                                      optionValue="value"
                                      ref="ctrldistrict"
                                      v-model="formData.district"
                                      :options="req.response"
                                      label="District"
                                      hint="Please select region before selecting district"
                                      placeholder="Select ..."
                                    >
                                    </Dropdown>
                                    <small
                                      v-if="isFieldValid('district')"
                                      class="p-error"
                                      >{{ getFieldError("district") }}</small
                                    >
                                  </template>
                                </api-data-source>
                              </div>
                            </div>
                            <div class="col-12 md:col-6">
                              <div class="mb-2 font-bold text-sm">
                                User Role (Access Level) *
                              </div>
                              <div id="ctrl-user_role-holder">
                                <api-data-source
                                  api-path="components_data/user_role_option_list"
                                >
                                  <template v-slot="req">
                                    <Dropdown
                                      class="w-full"
                                      :class="getErrorClass('user_role')"
                                      :loading="req.loading"
                                      optionLabel="label"
                                      optionValue="value"
                                      ref="ctrluser_role"
                                      v-model="formData.user_role"
                                      :options="req.response"
                                      label="User Role  (Access Level)"
                                      placeholder="Select ..."
                                    >
                                      <template #option="slotProps">
                                        <div class="flex align-items-center">
                                          <div>
                                            <div>
                                              {{ slotProps.option.label }}
                                            </div>
                                            <div
                                              v-if="slotProps.option.caption"
                                              class="text-sm text-500"
                                            >
                                              {{ slotProps.option.caption }}
                                            </div>
                                          </div>
                                        </div>
                                      </template>
                                    </Dropdown>
                                    <small
                                      v-if="isFieldValid('user_role')"
                                      class="p-error"
                                      >{{ getFieldError("user_role") }}</small
                                    >
                                  </template>
                                </api-data-source>
                              </div>
                            </div>
                          </div>
                          <!--[form-content-end]-->
                          <div v-if="showSubmitButton" class="text-center my-3">
                            <Button
                              type="submit"
                              label="Update"
                              class="p-button-rounded"
                              icon="pi pi-send"
                              :loading="saving"
                            />
                          </div>
                        </form>
                      </div>
                    </div>
                  </template>
                  <template v-if="loading">
                    <div class="p-3 text-center">
                      <ProgressSpinner style="width: 50px; height: 50px" />
                    </div>
                  </template>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  </div>
</template>
<script setup>
import { computed, reactive, toRefs, onMounted } from "vue";
import useVuelidate from "@vuelidate/core";
import { required } from "@/services/validators";
import { useApp } from "@/composables/app.js";
import { useEditPage } from "@/composables/editpage.js";
const props = defineProps({
  id: [String, Number],
  pageName: {
    type: String,
    default: "users",
  },
  routeName: {
    type: String,
    default: "usersedit",
  },
  pagePath: {
    type: String,
    default: "users/edit",
  },
  apiPath: {
    type: String,
    default: "users/edit",
  },
  submitButtonLabel: {
    type: String,
    default: "Update",
  },
  formValidationError: {
    type: String,
    default: "Form is invalid",
  },
  formValidationMsg: {
    type: String,
    default: "Please complete the form",
  },
  msgAfterUpdate: {
    type: String,
    default: "User updated successfully",
  },
  showHeader: {
    type: Boolean,
    default: true,
  },
  showSubmitButton: {
    type: Boolean,
    default: true,
  },
  redirect: {
    type: Boolean,
    default: true,
  },
  isSubPage: {
    type: Boolean,
    default: false,
  },
});
const app = useApp();
const formDefaultValues = Object.assign(
  {
    first_name: "",
    last_name: "",
    telephone: "",
    region: "",
    district: "",
    user_role: "",
  },
  props.pageData
);
const formData = reactive({ ...formDefaultValues });
function onFormSubmited(response) {
  app.flashMsg(props.msgAfterUpdate);
  if (props.redirect) app.navigateTo(`/users`);
}
const rules = computed(() => {
  return {
    first_name: { required },
    last_name: { required },
    telephone: { required },
    region: { required },
    district: { required },
    user_role: { required },
  };
});
const v$ = useVuelidate(rules, formData); //form validation
const page = useEditPage(props, formData, v$, onFormSubmited);
//page state
const {
  submitted, // form api submitted state - Boolean
  saving, // form api submiting state - Boolean
  loading, // form data loading state - Boolean
  pageReady, // if api data loaded successfully
} = toRefs(page.state);
//page computed propties
const {
  apiUrl, // page current api path
  currentRecord, // current page record  - Object
} = page.computedProps;
//page methods
const {
  load, // get editable form data from api
  submitForm, // submit form data to api
  getErrorClass, // return error class if field is invalid- args(fieldname)
  getFieldError, //  get validation error message - args(fieldname)
  isFieldValid, // check if field is validated - args(fieldname)
  // map api datasource  to Select options label-value
} = page.methods;
onMounted(() => {
  const pageTitle = "Edit User Account";
  app.setPageTitle(props.routeName, pageTitle); // set browser page title
  load();
});
</script>
<style scoped></style>
